<div class="row">
  <h2 class="col-12">{{station.name}}</h2>
  <h3 class="col-12">{{station.street}} {{station.city}}</h3>
  <div class="col-12">
  <div id="map" style="z-index: 0;">
    </div>
  </div>
  
</div>
